import { render, staticRenderFns } from "./TestQuestionSimple.vue?vue&type=template&id=3d2b3ff5&scoped=true&"
import script from "./TestQuestionSimple.vue?vue&type=script&lang=js&"
export * from "./TestQuestionSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b3ff5",
  null
  
)

export default component.exports